import showError from '@/handler/error';
import qs from 'query-string';
import { apiConfig } from '../api-config';

// eslint-disable-next-line consistent-return
export const getAppointment = async (params) => {
  const query = qs.stringify(params);
  const url = `api/appointments/get-by-id-agent-id-territory?${query}`;
  return apiConfig
    .get(url)
    .then(({ data }) => data.objectResult || [])
    .catch(showError);
};
